<template>
  <Notification 
    :show="flag" 
    @close="flag=false" 
    :title="title"
  >
    <div class="oc-notification" v-if="traceId">
      <span>Trace ID: </span><span class="highline">{{traceId}}</span><span class="copy" @click="Utils.copyHandle(traceId)">复制</span>
    </div>
  </Notification>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue'
  import EventBus from '@/assets/eventbus';
  import { Close, Upload, CloseBold } from '@element-plus/icons-vue'
  import { ElMessage, ElMessageBox, ElNotification } from 'element-plus'
  import Notification from '@/components/notification';
  import * as Request from '@/assets/request';
  import * as Utils from '@/assets/utils';

  const flag = ref(false);
  const title = ref('');
  const traceId = ref('');
  onMounted(() => {
    EventBus.on('order_notification', data => {
      console.log('data--', data);
      flag.value = true;
      title.value = data?.title;
      traceId.value = data?.traceId;
    })
  })
</script>

<style scoped lang="less">
  @import "./index.less";
</style>